import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class MainNavApiService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  // getAccounts(endpoint: string){
  //   //{ headers: headers, params: params }
  //   let url = `${this.url}/${endpoint}`;
  //   return this.http.get< AccountInterfaceData[]>(url);
  //   // {observe: 'response'} main.js:1 ERROR TypeError: t.payload is not iterable
  // } //end login

  get(endpoint: string){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.get(url,{observe: 'response'});
  } //end login

  delete(endpoint: string){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.delete(url,{observe: 'response'});
  } //end login



} // end class


